import {
  Box,
  Button,
  Collapse,
  HStack,
  IconButton,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MembershipFilterSummary } from "../../components/MemberFilterQueryModal/MemberFilterSummary";
import { FaRegCircleXmarkIcon } from "../../styles/icons";
import { FilterMode } from "./types";

interface SavedSegmentsSectionProps {
  filterMode: FilterMode;
  filterQuery: string;
  segmentName: string;
  hasSegments: boolean;
  onOpenModal: () => void;
  onOpenSelectModal: () => void;
  onClearSegment: () => void;
  onEditSegment?: () => void;
}

export const SavedSegmentsSection: React.FC<SavedSegmentsSectionProps> = ({
  filterMode,
  filterQuery,
  segmentName,
  hasSegments,
  onOpenModal,
  onOpenSelectModal,
  onClearSegment,
  onEditSegment,
}) => {
  const [filtersExpanded, setFiltersExpanded] = useState(false);

  return (
    <VStack w="100%" alignItems="flex-start" spacing={2}>
      <Text fontSize="sm" fontWeight="bold">
        Saved Segments
      </Text>
      <Text fontSize="sm" color="gray.700">
        Create custom filters to target members. Saved segments are reusable
        across all notifications, and scheduled notifications always use the
        filters as they were when created.
      </Text>

      {filterMode === "segment" && filterQuery ? (
        <Box
          w="100%"
          border="1px solid"
          borderColor="cherryBorder.200"
          borderRadius="md"
          bg="cherryBackground.subtleTile"
          p={3}
          pt={1}
        >
          <HStack justify="space-between" mb={2}>
            <Text fontWeight="semibold">{segmentName}</Text>
            <IconButton
              aria-label="Clear segment"
              icon={<FaRegCircleXmarkIcon />}
              variant="ghost"
              size="lg"
              color="gray.400"
              _hover={{ color: "gray.600" }}
              onClick={onClearSegment}
            />
          </HStack>
          <Button
            variant="link"
            color="cherryButton.800"
            size="sm"
            fontWeight="normal"
            _hover={{ textDecoration: "none" }}
            sx={{
              "&:hover > span:first-of-type": { textDecoration: "underline" },
            }}
            marginInlineStart={"0.3rem"}
            rightIcon={
              <Box
                as="span"
                display="inline-block"
                transform={filtersExpanded ? "rotate(90deg)" : "rotate(0deg)"}
                mt={"2px"}
                transition="transform 0.2s ease"
              >
                {">"}
              </Box>
            }
            onClick={() => setFiltersExpanded((prev) => !prev)}
          >
            <Box as="span">
              {filtersExpanded ? "Hide Filters" : "View Filters"}
            </Box>
          </Button>
          <Collapse in={filtersExpanded} animateOpacity>
            <Box pt={2}>
              <MembershipFilterSummary
                queryString={filterQuery}
                variant="compact"
              />
            </Box>
          </Collapse>
        </Box>
      ) : (
        <HStack spacing={2}>
          {hasSegments && (
            <Button variant="cherry-outline" onClick={onOpenSelectModal}>
              Select Segment
            </Button>
          )}
          <Button variant="cherry-outline" onClick={onOpenModal}>
            Create Segment
          </Button>
        </HStack>
      )}

      {filterMode === "segment" && filterQuery && (
        <HStack spacing={2}>
          {onEditSegment && (
            <Button variant="cherry-outline" onClick={onEditSegment}>
              Edit Segment
            </Button>
          )}
          <Button variant="cherry-outline" onClick={onOpenSelectModal}>
            Change Segment
          </Button>
        </HStack>
      )}
    </VStack>
  );
};
